module.exports = __webpack_public_path__ + "img/dashboard-en.67346107.png";